// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3pyQG","info":"UpdateTermsInfo_info__1ebJn"};